<div class="container-default pt-0 " [ngClass]="{'px-2 md:px-[initial]': isfullscreen}">
  <div class="flex flex-row justify-start md:justify-center mt-5 md:mt-[15px] p-[5px]">
    <h3 class="text-center mt-2.5">
      @if (productSearch.value && productSearch.value.length >=2) {
      {{'taxonomy.search' | translate}}
      } @else {
      {{_taxonomynode?.displayname}}
      }
    </h3>
  </div>
  <div class="g-0 store_top z-10 pb-2.5" [ngClass]="{'sticky top-[33px] md:top-[137px] bg-e-white': isfullscreen}">
    <div class="flex flex-row justify-between">
      <div>
        @if (_previousTaxonomyNodes.length > 0) {
        <button class="button rounded-full cursor-pointer" [disabled]="_previousTaxonomyNodes.length === 0 "
          (click)="gotoPreviousNode(_previousTaxonomyNodes[_previousTaxonomyNodes.length-1])">
          <i class="bi bi-arrow-left">{{'common.back_button'|translate}}</i>
        </button>
        }@else {
        <div class="buttonfill h-12"></div>
        }
        <div class="breadcrump_container">
          @for (node of _previousTaxonomyNodes; track node) {
          <a (click)="gotoPreviousNode(node)" class="font-semibold text-e-dark-green cursor-pointer">
            <small>{{node.displayname}} > </small>
          </a>
          }
          <span>
            @if (productSearch.value && productSearch.value.length >= 2) {
            <small> {{'taxonomy.search' | translate}} </small>
            } @else {
            <small>{{_taxonomynode?.displayname}}</small>
            }
          </span>
        </div>
      </div>
    </div>
    @if (showSearch) {
    <div class="search_container">
      <div class="form-field mt-1">
        <input type="search" #search tabindex="{{ 0}}" placeholder="{{'taxonomy.search_product' | translate}}" name="search_product" required [formControl]="productSearch"
          id="productsearch">
        @if (productSearch.value) {
        <button (click)="productSearch.markAsDirty(); productSearch.setValue(null)" class="absolute right-[15px] top-2.5 z-[1]"><i class="text-2xl bi bi-x-circle"></i></button>
        }
        @if (hasError('minlength')) {
        <span class="hint">{{'taxonomy.search_minlength_2' | translate}}</span>
        }
      </div>
    </div>
    }
  </div>


  @if (nodeError || productError || boxError) {
  <small class="flex flex-row">
    <span class="text-center error">{{'taxonomy.error_not_everything_is_shown' | translate}}</span>
  </small>
  }
  @if (!productSearch.value || productSearch.value.length <= 1) { <div
    class="grid bg-e-white rounded-lg min-h-[75vh] parentgrid {{isfullscreen? 'grid-cols-2 gap-2 p-0 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4': 'grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 p-6'  }}"
    id="childnodes">
    @if (loading) {
    <div class="flex flex-row justify-center my-[50px] absolute top-8 mx-auto">
      <app-loader></app-loader>
    </div>
    }
    @for (child of _taxonomynode?.taxonomyNodeChildNodes; track child; let i = $index) {
    @if (!child?.childtaxonomynode?.hidden && child?.childtaxonomynode?.enabled) {
    <div id="childnode-{{i}}" (click)="navigateToNode(child?.childtaxonomynode)">
      <div class="flex justify-center items-center relative rounded-lg min-h-[200px] md:min-h-[338px] overflow-hidden h-100 w-100 taxonomynode cursor-pointer">
        <app-image class="absolute top-0 right-0 left-0 bottom-0 min-h-[338px] object-cover" size="lg" [imageobject]="child.childtaxonomynode"></app-image>
        <h3 class="text-e-dark-green text-xl px-2.5 z-[5] text-shadow">{{child?.childtaxonomynode?.displayname}}</h3>
      </div>
    </div>
    }
    }
    <ng-container *ngTemplateOutlet="productlist; context: {'list':getChilds}"></ng-container>
</div>
} @else {
<div
  class="grid bg-e-white rounded-lg mt-6 min-h-[75vh] resultsgrid {{isfullscreen? 'grid-cols-2 gap-2 p-0 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4': 'grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 p-6'  }}">
  @if (searchResults && searchResults?.length === 0 && !loading) {
  <div class="flex flex-col justify-center">
    @if (!searchError) {
    <p class="text-center">{{'taxonomy.no_products_found' | translate}}</p>
    }
    @if (searchError) {
    <p class="text-center">{{'taxonomy.internal_server_error' | translate}}</p>
    }
  </div>
  }
  @if (loading) {
  <ng-container #loading>
    <app-loader></app-loader>
  </ng-container>
  }
  <ng-container *ngTemplateOutlet="productlist; context: {'list':searchResults}"></ng-container>
</div>
}

<ng-template #productlist let-list="list">

  @if (list && list.length === 0) {
  <span class="text-center error">{{'taxonomy.no_products_found' | translate}}</span>
  }

  @for (child of list; track child; let i = $index) {
  @if (child.product && child.product.shopsellprice && child.product.availableforwebshop || (child.box && child.box.boxcountryprices[0] && child.box.availableforwebshop) &&
  (!isfullscreen || isfullscreen && child.box && child.box.boxcountryprices[0] && child.box._availableforsingleorder)) {
  <div id="nodecontainer-{{i}}">
    @if (child.product) {
    <ng-container *ngTemplateOutlet="productTemplate;context:{$implicit:child.product}"></ng-container>
    } @else {
    <ng-container *ngTemplateOutlet="boxTemplate;context:{$implicit:child.box}"></ng-container>
    }
  </div>
  }
  }

</ng-template>
</div>